class GmVideoModal extends HTMLElement {
  connectedCallback() {
    this.showVideoBtn = this.querySelector("#video-btn");
    this.videoModal = this.querySelector("#video-modal");
    this.closeVideoBtn = this.querySelector("#close-btn");
    this.video = this.querySelector("video");

    if (!this.showVideoBtn || !this.videoModal || !this.closeVideoBtn) return;

    this.showVideoBtn.addEventListener("click", () => {
      this.videoModal.showModal();
      document.body.style.overflow = "hidden";

      if (this.video) {
        this.video.currentTime = 0;
      }
    });

    this.closeVideoBtn.addEventListener("click", () => {
      this.videoModal.close();
    });

    this.videoModal.addEventListener("click", (event) => {
      if (event.target === this.videoModal) {
        this.videoModal.close();
      }
    });

    this.videoModal.addEventListener("close", () => {
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
      }

      document.body.style.overflow = "";
    });
  }
}

if (!customElements.get("gm-video-modal")) {
  customElements.define("gm-video-modal", GmVideoModal);
}